import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export function TableCell(_ref) {
  var _node$colSpan, _node$rowSpan;
  var {
    children,
    node
  } = _ref;
  var Cell = node.isHeader ? 'th' : 'td';
  return /*#__PURE__*/_jsx(Cell, {
    className: classNames('prezly-slate-table-cell', {
      'prezly-slate-table-cell--header': node.isHeader
    }),
    colSpan: (_node$colSpan = node.colSpan) !== null && _node$colSpan !== void 0 ? _node$colSpan : node.colspan,
    rowSpan: (_node$rowSpan = node.rowSpan) !== null && _node$rowSpan !== void 0 ? _node$rowSpan : node.rowspan,
    style: {
      minWidth: node.width,
      maxWidth: node.width
    },
    children: children
  });
}